import "./header.scss";
import { allImages } from "../../services/images";
import { TiThMenu } from "react-icons/ti";
import { useState } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import { useAppDispatch, useAppSelector } from "../../Redux/hook";
import { light, dark } from "../../Redux/modeReducer";
import { useEffect } from "react";
import { links } from "../Reusable/resuable";
import { IoLocationOutline } from "react-icons/io5";
import { SocialMediaLinks } from "../../services/data";
import { IoMdArrowDropdown } from "react-icons/io";
export default function Header() {
    const [side, sidemenu] = useState("");
    const location = window.location.pathname;
    const lightmode = useAppSelector((state) => state.mode.lightMode);
    const [subside, subsidemenu] = useState("");
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (localStorage.getItem("mode") === "dark") {
            dispatch(dark());
        } else {
            dispatch(light());
        }
    }, []);
    return (
        <header>
            <div className="mainBanner">
                <div>
                    <a target="_blank" style={{ textDecoration: "none", color: "inherit" }} href="https://www.google.com/maps/place/PBL+Transport+Corporation+PVT+Ltd./@17.7268823,83.3023793,17z/data=!3m2!4b1!5s0x3a3943255ac01b4d:0x51bb14cbd05b7ae3!4m6!3m5!1s0x3a39433b5974f99f:0xc80cb6707fafe52d!8m2!3d17.7268823!4d83.3049542!16s%2Fg%2F1td63qyt?entry=ttu&g_ep=EgoyMDI1MDExNS4wIKXMDSoASAFQAw%3D%3D"><span><IoLocationOutline />&nbsp;&nbsp;<span style={{ lineHeight: '28px' }}>Rednam Plaza, 1st Floor, 2nd Lane, Dwaraka Nagar, Visakhapatnam, Andhra Pradesh 530016</span></span></a>
                    <div style={{ marginLeft: "20px" }}><strong>CIN NO : U63011AP1995PTC022556</strong></div>
                </div>
                {/* <div className="vehicleicons">
                    <img src={allImages.truckVector} alt="truck" height={40} />
                    <img src={allImages.forkliftVector} alt="truck" height={40} />
                    <img src={allImages.craneVector} alt="truck" height={40} /> 
                     <span>Follow Us  </span> 
                    <div className="iconslist">
                        <div className="icons">
                            {
                                SocialMediaLinks.map((item, i) => <a target="_blank" key={item.name} href={item.link} style={{ background: "transparent", color: item.color }} className="fb"><i>{item.icon}</i></a>)
                            }
                        </div>
                    </div>
                </div> */}
                <div className="icons">
                    {
                        SocialMediaLinks.map((item, i) => <a target="_blank" key={item.name} href={item.link}><i>{item.icon}</i></a>)
                    }
                </div>
            </div>
            <div className={`header ${!lightmode ? "headerbgB" : "headerbgW"}`}>
                <div className="logomenu">
                    <div className="menu"><TiThMenu color={!lightmode ? "white" : "#085D6B"} size={30} onClick={() => sidemenu(side === "gmenu" || side === "" ? "cmenu" : "gmenu")} /></div>
                    <a href="/"><img alt="prop" src={allImages.logo} /></a>
                    <div className="headlast menu">
                        <div className="toggleDark">
                            <input type="checkbox" className="checkbox" checked={lightmode} readOnly />
                            <label className="checkbox-label" onClick={() => {
                                if (lightmode) {
                                    localStorage.setItem("mode", "dark");
                                    dispatch(dark());
                                } else {
                                    localStorage.setItem("mode", "light");
                                    dispatch(light());
                                };
                            }}>
                                <FaSun className="fas fa-sun" />
                                <FaMoon className="fas fa-moon" />
                                <span className="ball"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="links">
                    {
                         links.map((item, i) => {
                            return <div className="link">
                                <div style={{marginRight:"25px"}}>
                                <a target={item.name === "Careers" ? "_blank" : ""} style={{ color: !lightmode ? "white" : "black" }} className={location === item.path ? "active" : ""} href={item.path} key={item.name}>{item.name}</a>
                                {item.submenu&&<IoMdArrowDropdown size={25}/>}</div>
                                {item.submenu&&<div className={`submenu ${lightmode?"lightMode":"darkMode"}`}>
                                    {
                                        item.submenu?.map((e,i)=>
                                        <a className={location === e.path ? "active" : ""} href={e.link?e.link:e.path} onClick={() => e.link&&window.open(e.link)} key={e.name}>{e.name}</a>
                                    )
                                    }
                                </div>}
                            </div>
                        })
                    }
                </div>
                <div className="headlast mv">
                    <a href="/contactus" style={{ textDecoration: "none" }}><div className="button">Contact Us</div></a>
                    <div className="toggleDark">
                        <input type="checkbox" className="checkbox" checked={lightmode} readOnly />
                        <label className="checkbox-label" onClick={() => {
                            if (lightmode) {
                                localStorage.setItem("mode", "dark");
                                dispatch(dark());
                            } else {
                                localStorage.setItem("mode", "light");
                                dispatch(light());
                            };
                        }}>
                            <FaSun className="fas fa-sun" />
                            <FaMoon className="fas fa-moon" />
                            <span className="ball"></span>
                        </label>
                    </div>
                </div>
                <div className={`sidemenu  ${side} ${lightmode?"lightMode":"darkMode"}`}>
                    <div className="links">
                    {
                         links.map((item, i) => {
                            return <div className="link">
                                <div>
                                <a onClick={()=>item.submenu&&subsidemenu(subside!==item.name?item.name:"")}  target={item.name === "Careers" ? "_blank" : ""} style={{marginLeft:item.submenu?"25px":"0px"}} className={location === item.path ? "active" : ""} href={item.submenu===undefined?item.path:"#"} key={item.name}>{item.name}</a>
                                {item.submenu&&<IoMdArrowDropdown size={30}/>}</div>
                                {item.submenu&&<div className="msubmenu" style={{display:subside===item.name?"flex":"none"}}>
                                    {
                                        item.submenu?.map((e,i)=>
                                        <a className={location === e.path ? "active" : ""} href={e.link?"#":e.path} onClick={() => e.link&&window.open(e.link)} key={e.name}>{e.name}</a>
                                    )
                                    }
                                </div>}
                            </div>
                        })
                    }
                    </div>
                    <a href="/contactus" style={{ textDecoration: "none" }}><div className="sbutton button">Contact Us</div></a>
                </div>
            </div>
        </header>

    );
}